/**
 * The product name, in one place.
 *
 * Norican I2Q (I2Q = Inquiry to Quote) turns customer inquiries into quotations and
 * does nothing else. In running text it is "Norican I2Q"; next to the Norican logo it
 * is just "I2Q", because the logo already says Norican. Technical names (the
 * `rfq_foundry` package, `rfq-foundry-*` resources, case ids such as `RFQ-...`, the
 * localStorage keys) keep their old spelling on purpose.
 */

/** The product name wherever a person reads it in running text. */
export const PRODUCT_NAME = "Norican I2Q";

/** The short name, next to the Norican logo. */
export const PRODUCT_SHORT = "I2Q";

/** What I2Q stands for, spelled out once where it helps. */
export const PRODUCT_SPELLED_OUT = "Inquiry to Quote";

/** The one purpose of the product, in one sentence. */
export const PRODUCT_PURPOSE =
  "Turns customer inquiries into draft quotations for sales to check. Nothing else.";
